<template>
  <div class="channels">
    <div
      class="channel"
      :class="{ selected: selectedTopic === 'all' }"
      @click="handleSelectTopic('all')"
    >
      <div class="type">*</div>
      <span class="room" :class="{ unread: allUnread > 0 }">all</span>
    </div>
    <div
      class="channel"
      v-for="tag in tags"
      :class="{ selected: selectedTopic === tag.topic }"
      :key="tag.name"
      @click="handleSelectTopic(tag.topic)"
    >
      <div class="type">#</div>
      <span class="room" :class="{ unread: tag.count > 0 }">{{ tag.name }}</span>
    </div>
    <div
      class="channel"
      v-for="user in users"
      :class="{
        selected: selectedTopic === user.topic,
        present: presentUserIds.includes(user.id),
        unpresent: !presentUserIds.includes(user.id),
      }"
      :key="user.id"
      @click="handleSelectTopic(user.topic)"
    >
      <div class="type">@</div>
      <span class="room" :class="{ unread: user.count > 0 }">
        {{ user.first_name }} {{ user.last_name }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ChannelSelector',
  props: {
    notifications: {
      type: Object,
      default: {},
    },
    selectedTopic: {
      type: String,
    },
    presences: {
      type: Object,
      default: {},
    },
  },
  mounted() {
    this.$store.dispatch('getCompanyUsers');
  },
  computed: {
    ...mapState('user', ['me', 'companyUsers']),

    users() {
      return this.companyUsers
        .filter(user => user.id !== this.me.id)
        .sort((a, b) => {
          // Prepend with a value to force present users to sort to the top
          const present = u => (this.presentUserIds.includes(u.id) ? 'AA' : 'ZZ');
          return `${present(a)} ${a.first_name} ${a.last_name}`.localeCompare(
            `${present(b)} ${b.first_name} ${b.last_name}`,
          );
        })
        .map(user => ({
          ...user,
          topic: this.userTopic(user),
          count: this.notificationCount(this.userTopic(user)),
        }));
    },

    tags() {
      // Ensure all is unique by using a Set
      return [...new Set(this.me.tags)].sort().map(tag => ({
        name: tag,
        topic: this.tagTopic(tag),
        count: this.notificationCount(this.tagTopic(tag)),
      }));
    },

    allUnread() {
      // Channel all unread count
      return this.notificationCount('all');
    },

    presentUserIds() {
      return Object.keys(this.presences).map(key => {
        // eslint-disable-next-line
        const [_, userId] = key.split(':');
        return parseInt(userId, 10);
      });
    },
  },
  methods: {
    tagTopic(tag) {
      return `tag:${tag}`;
    },

    userTopic(user) {
      const ids = [user.id, this.me.id].sort();
      return `user:${ids[0]},${ids[1]}`;
    },

    notificationCount(topic) {
      if (topic in this.notifications) {
        return this.notifications[topic].count || 0;
      }
      return 0;
    },

    handleSelectTopic(topic) {
      this.$emit('onSelectTopic', topic);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.channel {
  cursor: pointer;
  padding: 2px 6px;
}

.type {
  display: inline;
  font-size: 1.1em;
  font-weight: bold;
}

.present {
  .type {
    color: $colony-green;
  }
}

.unpresent {
  color: darken($colony-light-gray, 20%);
  font-style: italic;
}

.unread {
  font-weight: bold;
  color: black;
}

.selected {
  background-color: $colony-light-gray;
}
</style>



// WEBPACK FOOTER //
// ChannelSelector.vue?38df52ed